import React, { useState, useEffect } from 'react';
import './../../entrydoor.css';
import { formatToDecimal } from '../conversions';
import { formatToFractional } from '../conversions';


const OverallHeight = ({ value, onChange, label = 'Overall Height:', disabled = false }) => {
    const [selectedOverallHeight, setSelectedOverallHeight] = useState(value || "");
     const [OverallHeightError, setOverallHeightError] = useState("");

    const handleOverallHeightChange = (e) => {
        //setSelectedOverallHeight(e.target.value);
        validateOverallHeight(e.target.value);
        onChange(e.target.value);
    };
    const validateOverallHeight = (value) => {
        const numericValue = value; //.replace(/\D/g, ""); // Allow only numbers
        setSelectedOverallHeight(numericValue);

        const transom = document.getElementById('Transom').value;
        if (transom !== "None") {
            const height = parseInt(document.getElementById('FrameHeight').value, 10);

            if (numericValue && (numericValue <= height || numericValue > 200)) {
                setOverallHeightError(`Overall Height must be greater than ${height}" and less than 200"`);
            } else {
                setOverallHeightError("");
            }
        }        
    };

    const handleFocus = (e) => {
      const decimalValue = formatToDecimal(e.target.value);
      setSelectedOverallHeight(decimalValue);
    };

    const handleBlur = (e) => {
      const fractionalValue = formatToFractional(e.target.value);
      setSelectedOverallHeight(fractionalValue);
      onChange(fractionalValue);
    };
    useEffect(() => {
        onChange(value);
    }, []); // only once on mount

    return (
            <div className="a-container">
                <label disabled={disabled} htmlFor="OverallHeight">{label}</label>
                <input
                    disabled={disabled}
                    id="OverallHeight"
                    value={selectedOverallHeight}
                    onChange={handleOverallHeightChange}
                    onFocus={handleFocus}
                    onBlur={handleBlur}
                />
                {OverallHeightError && <p className="error">{OverallHeightError}</p>}
            </div>
    );
};

export default OverallHeight;
